import GeoJSON from 'ol/format/GeoJSON.js';

export default function readfeaturesWithProj(from, to, data, format) {
    var result;
    if (from == to) {
        result = format.readFeature(data);
    } else {
        if (from != 'EPSG:3857' && to != 'EPSG:3857') {
            var feature = format.readFeature(data, {
                featureProjection: 'EPSG:3857',
                dataProjection: from
            });

            try {

                var new_data = format.writeFeature(feature, {
                    featureProjection: 'EPSG:3857',
                    dataProjection: to
                });
                result = format.readFeature(new_data);

            } catch (e) {

                var new_data = (new GeoJSON()).writeFeature(feature, {
                    featureProjection: 'EPSG:3857',
                    dataProjection: to
                });
                result = (new GeoJSON()).readFeature(new_data);

            }

        } else {
            result = format.readFeature(data, {
                featureProjection: to,
                dataProjection: from
            });
        }
    }
    return result;
};
